export { default } from './custom-image.component';
